import styled from '@emotion/styled';

export enum FontFamily {
  normal = 'Roboto',
  special = 'Montserrat',
}

export enum FontSize {
  smallest = '12px',
  // smaller = ???,
  small = '16px',
  normal = '18px',
  large = '24px',
  larger = '32px',
  largest = '48px',
}

export enum FontWeight {
  thin = '400',
  normal = '500',
  bold = '600',
  bolder = '800',
}

export enum LineHeight {
  small = 'calc(4/3)',
  normal = 'calc(3/2)',
  large = 'calc(52/32)',
  largest = 'calc(32/18)',
}

export enum Size {
  smaller = '16px',
  small = '24px',
  medium = '32px',
  large = '48px',
}

export enum PaletteColor {
  white = '#ffffff',
  gray = '#e5e5e5',
  text = '#002a5a',
  highlightBackground = '#f3f9ff',
  bright = '#0071F3',
  brightDisabled = '#003066',
}

const AppStyles = styled.div`
  /*
		Default text matches Figma "Desktop/Body Text Large Bold"
	*/
  font-family: ${FontFamily.normal};
  font-weight: ${FontWeight.normal};
  color: ${PaletteColor.text};

  font-size: ${FontSize.normal};
  line-height: ${LineHeight.largest};

  a {
    color: inherit;
    text-decoration: none;
  }
`;

export default AppStyles;
